export default "__VITE_ASSET__0946b57c__"